import AppCopy from "copy/AppCopy";
import { StaffCardProps } from "declarations/card";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setStaff } from "reducers/userReducer";
import { Paths } from "router/Paths";

function StaffCard({ staff }: StaffCardProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { emailText, nameText, phoneText, statusText } = AppCopy.staffPage;

  const handleOnClickStaff = () => {
    dispatch(setStaff(staff));
    navigate(`${Paths.staff}/${staff._id}`);
  };

  return (
    <div className={Classname.container} onClick={handleOnClickStaff}>
      <div className={Classname.phoneNo}>
        <span className={Classname.title}>{phoneText}</span>
        <span className={Classname.carTag}>{staff.phoneNumber || "No phone"}</span>
      </div>
      <div className={Classname.fullName}>
        <span className={Classname.title}>{nameText}</span>
        <span>{staff.name || "Unnamed staff"}</span>
      </div>
      <div className={Classname.email}>
        <span className={Classname.title}>{emailText}</span>
        <span className="break-all">{staff.email || "No email"}</span>
      </div>
      <div className={Classname.status}>
        <span className={Classname.title}>{statusText}</span>
        <span>{staff.isActive ? "Active" : "Suspended"}</span>
      </div>
    </div>
  );
}

export default StaffCard;

const Classname = {
  container:
    "flex w-full flex-shrink-0 cursor-pointer flex-col justify-between border-b border-slate-100 px-2 py-3 text-sm text-secondaryText transition-colors hover:bg-slate-50 sm:min-h-14 sm:flex-row sm:items-center",
  phoneNo: "w-full sm:w-1/5 my-1 sm:my-0 ",
  fullName: "w-full sm:w-1/5 my-1 sm:my-0 ",
  email: "w-full sm:w-1/5 flex flex-col sm:flex-row my-1 sm:my-0 ",
  status: "w-full sm:w-1/5 flex flex-col sm:flex-row my-1 sm:my-0 ",

  title: "flex sm:hidden my-2 text-xs text-secondaryText",

  carTag:
    "flex items-center justify-center w-fit px-2 bg-bgSecondary rounded-md text-primaryText",
  carTagBold: "font-bold",
};
